// Clinical specialty options shared across employer forms where appropriate
export const specialties = [
  "Internal Medicine",
  "General Surgery",
  "Emergency Medicine",
  "Trauma",
  "Orthopaedics",
  "Paediatrics",
  "Gynaecology",
  "Obstetrics",
  "Psychiatry",
];

// Business-facing role categories that align with the employee onboarding chips
export const roleCategories = [
  "Business/Consulting",
  "Clinical Medicine",
  "Clinical Research",
  "Entrepreneurship",
  "HealthTech",
  "Hospital/Clinic Management",
  "Insurance",
  "Marketing/Sales",
  "Medical Communication",
  "Medical Education",
  "Pharmaceuticals",
  "Policy/Legal/Ethics",
  "Project Management",
  "Wellness/lifestyle",
];
